export const PRESERVICE_SHARED_IDENTITY_FIELDS = [
  "firstName",
  "fatherName",
  "grandFatherName",
  "sex",
  "dateOfBirth",
  "backgroundProfession",
  "nationality",
  "ethnicity",
  "birthRegionId",
  "birthZoneId",
  "birthWoredaId",
  "birthTownVillage",
];

export const applySharedPreserviceIdentity = (target = {}, source = {}) =>
  PRESERVICE_SHARED_IDENTITY_FIELDS.reduce(
    (nextValues, field) =>
      Object.prototype.hasOwnProperty.call(source, field)
        ? {
            ...nextValues,
            [field]: source[field],
          }
        : nextValues,
    { ...target },
  );
